module.exports = __webpack_public_path__ + "static/media/fci_animals_form.5e7935ae.png";